import React from "react";
import { Layout } from "antd";

const { Footer } = Layout;

export default class FooterSite extends React.Component {
    
  render() {
    return (
      <Footer style={{ textAlign: "center", backgroundColor: "rgb(255 0 0 / 0%)" }}>
        <div style={{ padding: "3px", margin: "10px" }} >
          <span style={{ color: "rgb(255 0 0 / 0%)" }}>Version {process.env.REACT_APP_ROOT_VERSION}</span>
        </div>
      </Footer>
    );
  }
}
